import React, { useEffect, useState } from "react";
import { Card, Icon, message, Upload } from "antd";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import { SERVER } from "../../../../api";
import ehrazimage from '../../../UserPanel/verification/pic/ehraz.jpg'
import ImgCrop from 'antd-img-crop';
import "./dragdrop.scss";
import moment from "moment";
import { expireToken } from "../../../../api";
const Dragger = Upload.Dragger;

let authorizeSampleStyle = {
  display: 'flex',
  height: "400px",
  margin: "10px auto",
  borderRadius: "4px"
}
let authorizeTextStyle = {
  margin: "0 auto",
  width: "80%",
  padding: "20px 0px"
}
let authorizeSampleTextStyle = {
  textAlign: "center"
}



const DragDrop = (uploadProps) => {
  const [auth, setAuth] = useState()


  function getToken() {
    if (
      localStorage.getItem("accessToken") &&
      localStorage.getItem("accessToken").length > 0
    ) {
      let lastRefresh = localStorage.getItem("tokenDate");
      if (lastRefresh && (Math.abs(moment(lastRefresh).diff(moment.utc(), 'seconds'))) > expireToken) {
        axios.get(SERVER + `/User/Token/${localStorage.getItem('refToken')}`).then(res => {
          localStorage.setItem("refToken", res.data.data.refresh_token);
          localStorage.setItem("accessToken", res.data.data.access_token);
          localStorage.setItem("tokenDate", moment.utc())
          setAuth('Bearer ' + res.data.data.access_token)
        })
      }
      else
        setAuth('Bearer ' + localStorage.getItem("accessToken"))
    }
  }

  const onPreview = async file => {
    let src = file.url;
    if (!src) {
      src = await new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  const props = {
    name: uploadProps.name,
    multiple: uploadProps.multiple,
    action: uploadProps.url,
    hasSample: uploadProps.hasSample,
    listType: "picture-card",
    //beforeUpload: getToken(),
    //disabled:true,
    headers: { 'Authorization': auth },
    accept: uploadProps.accept,
    onChange(info) {

      const status = info.file.status;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        toast.success(info.fileList[0].response.message)
        // message.success(`${info.file.name} پرونده با موفقیت بارگذاری شد`);
        uploadProps.finish(info.file, info.fileList)
      } else if (status === 'error') {
        getToken()
        toast.error(info.fileList[0].response.message)
        // message.error(`${info.file.name} آپلود پرونده انجام نشد`);
      }
    },
  };

  return (
    <div style={{ margin: '18px 0', width: '100%' }} onClick={getToken}>
      {console.log(props)}
      {props.hasSample &&
        <div>
          <div>
            <img
              alt="ehrazimage"
              src={ehrazimage}
              style={{ ...authorizeSampleStyle }} />
            <p style={{ ...authorizeSampleTextStyle }} >تصویر نمونه</p>
          </div>
          <div style={{ ...authorizeTextStyle }}>
            <p>
              متن روی برگه :
              <br />
              اینجانب.... ضمن مطالعه کامل قوانین و مقررات، مدارک خود را جهت احراز هویت در وب سایت مجموعه تم ایکس ارسال‌می نمایم و متعهد می شوم حساب کاربری خود را در اختیار هیچ شخص دیگری قرار ندهم.
              <br />
              نام و نام خانوادگی
              تاریخ:                       امضا:
            </p>
          </div>
        </div>
      }
      {
        props.accept == "image/*" ?
          <ImgCrop rotate zoom={true} minZoom={0} aspect={5 / 3.5} modalTitle="ویرایش"	>
            <Upload onPreview={props.accept == "image/*" ? onPreview : ''} {...props}>
              <p className="ant-upload-drag-icon">
                <Icon type="inbox" />
              </p>
              <p className="ant-upload-text">برای بارگیری ، روی این منطقه کلیک کنید یا بکشید</p>
            </Upload>
          </ImgCrop>
          :
          <Upload onPreview={props.accept == "image/*" ? onPreview : ''} {...props}>
            <p className="ant-upload-drag-icon">
              <Icon type="inbox" />
            </p>
            <p className="ant-upload-text">برای بارگیری ، روی این منطقه کلیک کنید یا بکشید</p>
          </Upload>
      }

    </div >
  );
}
  ;

export default DragDrop;
